import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../../monitor';
import { inViewOnlyMode } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { rowIsRightClickable } from '../../../../../store/slices/viewportSlice';
import { useAppSelector } from '../../../../hooks';
import { useContextMenuHandler } from '../NavigationPanelRow';
import { RowActionButton } from './common/RowActionButton';
import { RowButtonProps } from './common/RowButtonProps';

export function RowMenuButton({ row }: RowButtonProps) {
  const monitor = useAppMonitor();
  const handler = useContextMenuHandler(row);

  const viewOnly = useAppSelector(inViewOnlyMode);
  const hasPermission = useAppSelector(hasTrussDesignPermission);

  if (viewOnly || !hasPermission) return null;

  return rowIsRightClickable(row) ? (
    <RowActionButton
      id="row-menu"
      name="row-menu"
      icon={MoreVertIcon}
      title="Menu"
      onClick={(event) => {
        monitor.recordInteraction('Navigation row menu opened', { type: row.type });
        handler(event);
      }}
    />
  ) : null;
}
